import { Injectable } from '@angular/core';
import { ApiHelper } from 'src/cad/common/services/api/api-helper';
import { Observable } from 'rxjs';
import { CapacityDetails } from 'src/cad/capacity-analysis/interfaces/capacity-review/capacity-details';
import { PointDetails } from 'src/cad/capacity-analysis/interfaces/capacity-review/point-details';
import { CapacityReview } from 'src/cad/capacity-analysis/interfaces/capacity-review/capacity-review';
import { UserModelService } from 'src/cad/common/services/user/user-model-service';
import { ApprovalStatusEnum } from 'src/common/types/cad.constants';
import { map } from 'rxjs/operators';
const { NOT_YET_REVIEWED } = ApprovalStatusEnum;

@Injectable()
export class CapacityAnalysisReviewApi {
  private readonly endpoint: string = 'capacity-analysis/';

  constructor (
    private apiHelper : ApiHelper,
    private userModelService: UserModelService  ) {
  }

  public getCapacityReview(): Observable<CapacityReview[]> {
    return this.apiHelper.request(this.endpoint + 'capacity-review').pipe(
      map((data) =>
        data.map((item) => ({
          ...item,
          approvalStatusCd: NOT_YET_REVIEWED
        }))
    ));
  }

  public getPointDetails(contractId: number): Observable<PointDetails[]> {
    const reqObj = {
      contractId, assetNbr:this.userModelService.getCurrentContext().assetNbr
    };
    return this.apiHelper.request(this.endpoint + 'cas-point-details', { body:reqObj });
  }

  public getCapacityDetails(pointCd: string, dirOfFlow: string, effBeginDt: string, effEndDt: string, capacityQty: string): Observable<CapacityDetails[]> {
    const reqObj = {
      assetNbr:this.userModelService.getCurrentContext().assetNbr,pointCd, dirOfFlow, effBeginDt, effEndDt, requiredCapacityQty: capacityQty
    };
    return this.apiHelper.request(this.endpoint + 'cas-capacity-details', { body:reqObj });
  }

}
